import { render } from "./CrearOrdenEntrada.vue?vue&type=template&id=4aa8e90b&scoped=true"
import script from "./CrearOrdenEntrada.vue?vue&type=script&lang=js"
export * from "./CrearOrdenEntrada.vue?vue&type=script&lang=js"

import "./CrearOrdenEntrada.vue?vue&type=style&index=0&id=4aa8e90b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa8e90b"]])

export default __exports__